<template>
    <div class="container m-0-a">
        <div class="top-des-wrap" v-if="topDesInfo">
            <top-des :info="topDesInfo" :lan="language"></top-des>
        </div>
        <div class="session-one-wrap" :style="{backgroundImage: 'url(' + sessionOneInfo.head_bg + ');' }" v-if="sessionOneInfo">
            <session-one :info="sessionOneInfo" :gameCode="gameCode" :lan="language"></session-one>
            <down-load :info="sessionOneInfo" :lan="language"></down-load>
        </div>
        <div :class="[{'has-margin-bottom':isMobile},'session-second-wrap']" :style="{backgroundImage: 'url(' + sessionSecondInfo.bg + ');' }">
            <video-des :info="videoInfo" :lan="language" v-if="videoInfo"></video-des>
            <link-tab :info="linkInfo" :lan="language" v-if="linkInfo"></link-tab>
            <game-feature :info="featureInfo" v-if="featureInfo"></game-feature>
            <king-trial :info="trialInfo" :lan="language" v-if="trialInfo"></king-trial>
            <game-intro :info="introInfo" v-if="introInfo"></game-intro>
            <foot></foot>
        </div>
        <mb-bar :info="barInfo" :lan="language" v-if="barInfo"></mb-bar>
    </div>
</template>
<style lang="less" scoped>
    .container {
        .top-des-wrap {
            background: #000;
        }
        .session-one-wrap {
            height: 12.08rem;
            background-position: center 0;
            background-size: cover;
        }
        .session-second-wrap {
            padding-top: .32rem;
            background-size: cover;
            background-position: center 0;
        }
        .has-margin-bottom {
            margin-bottom: 1.33333rem;
        }
    }
    @media screen and (min-width:1025px) {
        [pc="1"] .session-one-wrap {
            height: 906px;
            background-size: 100% 100%;
        }
        [pc="1"] .session-second-wrap {
            background-size: 100% 100%;
        }
    }
</style>

<script>
    import Util from "@util/index.js";
    import controller from "@controller/index.js";
    import topDes from '@components/index/top-des'
    import sessionOne from '@components/index/session-one'
    import downLoad from '@components/index/downLoad'
    import videoDes from '@components/index/video-des'
    import linkTab from '@components/index/link-tab'
    import gameFeature from '@components/index/game-feature'
    import kingTrial from '@components/index/king-trial'
    import gameIntro from '@components/index/game-intro'
    import foot from '@components/common/foot/index.vue'
    import mbBar from '@components/common/bar/index'
    export default {
        components: {
            topDes,
            sessionOne,
            downLoad,
            videoDes,
            linkTab,
            gameFeature,
            kingTrial,
            gameIntro,
            foot,
            mbBar
        },
        asyncData(payload) {
            try {
                if (process.server) {
                    const dataInfo = payload['payload']['picData'];
                    // console.log('........................')
                    // console.log(JSON.stringify(payload['payload'].webMark))
                    const info = controller.initPic(dataInfo.list);
                    const barInfo = controller.initBarInfo(dataInfo.gameItemInfo, payload['payload'].webMark, payload['payload'].isPreference, payload['payload'].lan, payload['payload'].testPath);
                    const pcBarInfo = controller.getPCBarInfo(dataInfo.list, payload['payload'].isPreference, payload['payload'].lan)
                    console.log('......       页面标题           .........')
                    console.log(JSON.stringify(barInfo))
                    return {
                        language: payload['payload'].language,
                        seoInfo: payload['payload'].seoInfo,
                        faviconIcon: payload['payload'].faviconIcon,
                        gameCode: payload['payload'].gameCode,
                        topDesInfo: info.topDesInfo,
                        sessionOneInfo: info.sessionOneInfo,
                        barInfo: Object.assign({
                            path: 'index',
                        }, barInfo, pcBarInfo),
                        sessionSecondInfo: info.sessionSecondBg,
                        videoInfo: info.videoInfo,
                        linkInfo: info.linkInfo,
                        featureInfo: info.featureInfo,
                        trialInfo: info.trialInfo,
                        introInfo: info.introInfo
                    }
                }
            } catch (e) {}
        },
        data() {
            return {
                isMobile: false
            }
        },
        head() {
            return {
                title: this.seoInfo.title,
                link: [{
                    rel: 'icon',
                    href: this.faviconIcon
                }, ],
                meta: [{
                        'property': 'og:url',
                        name: 'url',
                        content: this.seoInfo.url
                    },
                    {
                        'property': 'og:image',
                        name: 'image',
                        content: this.seoInfo.image
                    },
                    {
                        'property': 'og:title',
                        name: 'title',
                        content: this.seoInfo.title
                    },
                    {
                        'property': 'og:description',
                        name: 'description',
                        content: this.seoInfo.description
                    },
                    {
                        'property': 'og:keywords',
                        name: 'keywords',
                        content: this.seoInfo.keyword
                    }
                ]
            }
        },
        mounted() {
            console.log(this.seoInfo)
            Util.deviceType() == 'mb' ? this.isMobile = true : this.isMobile = false;
            Util.addSesstion('gameCode', this.gameCode);
            Util.addSesstion('ga-id', this.seoInfo.ga);
        }
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/pages/index.vue